export function getFileNameFromContentDisposition(disposition, fallback = '') {
  const encoded = String(disposition || '').match(/filename\*=UTF-8''([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].replace(/^\x22|\x22$/g, ''));
    } catch {
      return fallback;
    }
  }
  return String(disposition || '').match(/filename=\x22?([^\x22;]+)\x22?/i)?.[1] || fallback;
}

/** Trigger a browser download for a URL that the caller already acquired. */
export function triggerBrowserDownload({ href, fileName = '' }) {
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.download = fileName;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
